import { reportAPIFailure } from 'src/dataLayer/remoteData/rollbar'

const EMPTY_ERROR = ''

const getErrorText = (triggeredError, errorCode) =>
  triggeredError[errorCode]?.key || triggeredError.key || EMPTY_ERROR

const successHandler = async (response) => {
  if (response.ok) {
    // eslint-disable-next-line no-return-await -- Legacy
    return await response.json()
  }

  const { error } = await response.json()

  // we need to destructure error attribute otherwise
  // it will have { error: error {} } structure
  // eslint-disable-next-line no-throw-literal -- Legacy
  throw {
    ...error,
    status: response.status,
  }
}

const failureHandler = (error, { errorKeys, payload }) => {
  reportAPIFailure(error, payload)
  const triggeredError = errorKeys[error.status] || errorKeys.default
  throw getErrorText(triggeredError, error.code)
}

export { failureHandler, getErrorText, successHandler }
